<div class="body">

    <mat-form-field class="width" [appearance]="appearance">
        <mat-label>Icon wählen</mat-label>

        <mat-select [value]="currentSelection">
            <mat-select-trigger *ngIf="currentSelection">
                <mat-icon [style.color]="color">
                    {{currentSelection.code}}
                </mat-icon>
            </mat-select-trigger>
            <mat-option *ngFor="let icon of materialIconsCollection" (click)="setIcon(icon)" class="option" [value]="icon">
                <mat-icon class="icon">
                    {{icon.code}}
                </mat-icon>
            </mat-option>
        </mat-select>
        
    </mat-form-field>

</div>